import { IObjectTranslatable, RelationalActionTranslator } from ".";
import { ICheckBoxItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, CheckBoxItem } from "../../../../domain/document/items";
import { HtmlColorCodeTranslator } from "./HtmlColorCodeTranslator";
import { HisItemParameterTranslator } from "../../../his/ver2/HisItemParameterTranslator";
import { RelationalActionExtractor } from "./RelationalActionExtractor";
import { Point, Size, Rectangle } from "../../../../domain/drawing";


export class CheckBoxItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as ICheckBoxItemBean;
    const result = new CheckBoxItem(bean.selected, bean.checkedScore, bean.defaultScore);
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.name = bean.name;
    result.groupKey = bean.groupKey;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.shouldQuote = !!bean.isQuotable;
    result.supportedQuotable = !!bean.supportedQuotable;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.isMultiCheckable = bean.isMultiSelect;
    result.checkStyle = bean.checkStyle;
    result.enableNameGroupEmptyCheck = bean.nameGroupEmptyCheck;
    result.enableEmptyCheckConfirmation = bean.isEmptyCheckIgnorable;
    result.text = bean.text;
    result.patientProfileOption = bean.patientProfileOption;
    result.itemName = bean.itemName;
    result.isHisInfo = bean.isHisInfo;
    result.displayName = bean.displayName;
    result.toolTip = bean.toolTip;
    result.hisItemParameter = HisItemParameterTranslator.toHisItemParameter(bean.hisItemParameter);
    result.scriptExecuteParameters = RelationalActionExtractor.extractScriptExecuteParameters(result.actions);
    result.isNaturalViewEnable = bean.naturalView;
    result.naturalText = bean.naturalText;
    result.pasteDestinations = RelationalActionExtractor.extractTextPasteParameters(result.actions);
    result.parentAlertInformations = RelationalActionExtractor.extractParentAlertParameters(result.actions);
    result.groupName = bean.itemName; // 分類名がグループ名称になる
    result.isDialogMultiSelectable = !!bean.enabledHisMultiSelect;
    result.isFreeInputable = !!bean.supportedFreeText;
    result.shouldInputFree = !!bean.enabledFreeText;
    result.shouldDrawBorder = bean.frameVisible;
    result.paintStyle = HtmlColorCodeTranslator.toPaintStyleFill(bean.backColor);
    result.paintStyleOnEditing = bean.isDisplayBackColorSpecified
      ? HtmlColorCodeTranslator.toPaintStyleFill(bean.displayBackColor)
      : null;
    result.shouldLinkAsWideScope = !!bean.isWideScope;
    result.dacsProcessType = bean.dacsProcessType;
    result.dacsItemName = bean.dacsItemName;
    result.dacsItemCode = bean.dacsItemCode;
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    const target = item as CheckBoxItem;
    const bean: ICheckBoxItemBean = {
      type: BeanTypes.Check,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      name: target.name,
      groupKey: target.groupKey,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      isMultiSelect: target.isMultiCheckable,
      checkedScore: target.checkedValue,
      defaultScore: target.uncheckedValue,
      frameVisible: target.shouldDrawBorder,
      selected: target.isChecked,
      checkStyle: target.checkStyle,
      relationalItems: null,  // TODO:返却する必要ある？
      nameGroupEmptyCheck: target.enableNameGroupEmptyCheck,
      isEmptyCheckIgnorable: target.enableEmptyCheckConfirmation,
      text: target.text,
      patientProfileOption: target.patientProfileOption,
      itemName: target.itemName,
      isHisInfo: target.isHisInfo,
      displayName: target.displayName,
      toolTip: target.toolTip,
      isQuotable: target.shouldQuote,
      supportedQuotable: target.supportedQuotable,
      hisItemParameter: null, // 返却する必要なし
      naturalView: target.isNaturalViewEnable,
      naturalText: target.naturalText,
      supportedFreeText: target.isFreeInputable,
      enabledFreeText: target.shouldInputFree,
      enabledHisMultiSelect: target.isDialogMultiSelectable,
      backColor: HtmlColorCodeTranslator.fromPaintStyle(target.paintStyle),
      displayBackColor: HtmlColorCodeTranslator.fromPaintStyle(target.paintStyleOnEditing),
      isDisplayBackColorSpecified: !!target.paintStyleOnEditing,
      isWideScope: target.shouldLinkAsWideScope,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
      dacsProcessType: target.dacsProcessType,
      dacsItemName: target.dacsItemName,
      dacsItemCode: target.dacsItemCode,
    };
    return bean;
  }
}
